<template>
  <div class="video-uploader">
    <div class="video-uploader__preview">
      <!-- <div class="video-uploader__empty" v-show="!videoLink">
        <span>Вставьте ссылку на видео</span>
      </div> -->
      <!-- <iframe
        v-show="videoLink"
        width="560"
        height="315"
        :src="videoLink"
        title="YouTube video player"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowfullscreen
      /> -->
    </div>
    <h2 class="video-uploader__title">Ссылка:</h2>
    <InputText
      type="text"
      v-model="videoLink"
      placeholder="Вставьте ссылку на видео"
      style="width: 100%;"
    />
    <div class="video-uploader__buttons">
      <BaseBtnNew
        name="Сохранить"
        @click-btn="$emit('saveVideo', videoLink)"
      >
        <SaveIconNew/>
      </BaseBtnNew>
      <BaseBtnNew
        red
        name="Отменить"
        @click-btn="$emit('closeModal', 'all', false)"
      >
        <CancelIcon/>
      </BaseBtnNew>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue'

import InputText from 'primevue/inputtext'
import BaseBtnNew from '@/components/ui/BaseBtnNew.vue'
import CancelIcon from '@/components/icons/CancelIcon.vue'
import SaveIconNew from '@/components/icons/SaveIconNew.vue'

export default {
  name: 'VideoUploader',
  components: {
    InputText,
    SaveIconNew,
    CancelIcon,
    BaseBtnNew
  },
  setup () {
    const videoLink = ref()

    return {
      videoLink
    }
  }
}
</script>

<style lang="scss" scoped>
.video-uploader {
width: 768px;
height: 150px;

  // width: 580px; // врееменно
  // height: 300px;//временно
  &__title {
    text-align: left;
    font-weight: 500;
    font-size: 18px;
  }

  &__empty {
    @include flex-center;
    padding: 10px;
    width: 560px;
    height: 315px;
    background-color: #CCCCCC;
    text-align: center;
    vertical-align: center;
    font-size: 34px;
    font-weight: 500;
    color: #FFFFFF;
  }

  &__buttons {
    position: absolute;
    right: 0px;
    left: 0px;
    bottom: 0px;
    padding: 24px;
    border-top: 2px solid #D6D6D6;
    background-color: #F5F5F5;
    display: flex;
    justify-content: flex-end;
    gap: 30px;
    width: 100%;
    :deep(.base-button) {
      width: 200px;
    }
  }
}
:deep(.p-inputtext) {
  width: 100%;
  max-width: 839px;
  border: 1px solid #000000;
  // -webkit-box-shadow: inset 0 0 0 50px white;
}

:deep(.p-inputtext:enabled:hover) {
  border-color: #00ABEC;
}
:deep(.p-inputtext:disabled) {
  opacity: 0.5;
}

:deep(.p-inputtext:enabled:focus) {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: 0 0 0 0.1rem #00ABEC;
  border-color: #00ABEC;
  -webkit-box-shadow: inset 0 0 0 50px white;
}
</style>
